import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=15c2ef4d&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=15c2ef4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c2ef4d",
  null
  
)

export default component.exports